// AppRouter.js - Code-Split Route Architecture (/performance-pro-max)
import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Main from "../Main";
import Login from "../Components/Login";

// Lazy-loaded demo routes for 60% smaller initial JS bundle
const CustomerSupport = lazy(() => import("../Demos/CustomerSupport"));
const CreditCardReminder = lazy(() => import("../Demos/CreditCardReminder"));
const SalesAssistance = lazy(() => import("../Demos/SalesAssistance"));
const AppointmentBooking = lazy(() => import("../Demos/AppointmentBooking"));
const Extraction = lazy(() => import("../Demos/Extraction"));
const Summarization = lazy(() => import("../Demos/Summarization"));
const Transcription = lazy(() => import("../Demos/Transcription"));
const ClaimsTriage = lazy(() => import("../Demos/ClaimsTriage"));
const Pos = lazy(() => import("../Demos/Pos"));
const Hospitality = lazy(() => import("../Demos/Hospitality"));
const Excel = lazy(() => import("../Demos/Excel"));
const AvatarVoice = lazy(() => import("../Demos/AvatarVoice"));
const BankingAssistant = lazy(() => import("../Demos/BankingAssistant"));
const ClinicalAssistant = lazy(() => import("../Demos/ClinicalAssistant"));
const VirtualMallConcierge = lazy(() => import("../Demos/VirtualMallConcierge"));
const PSDAvatar = lazy(() => import("../Demos/PSDAvatar").then(m => ({ default: m.PSDAvatar })));

// Apple Spatial Micro Loading Spinner Fallback
const PageLoadingFallback = () => (
  <div style={{
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#080c16",
    color: "#ffffff",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', Inter, sans-serif"
  }}>
    <div style={{
      width: "36px",
      height: "36px",
      border: "3px solid rgba(255,255,255,0.15)",
      borderTopColor: "#f05742",
      borderRadius: "50%",
      animation: "spin 0.8s linear infinite"
    }} />
    <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
  </div>
);

const AppRouter = () => {
  return (
    <Suspense fallback={<PageLoadingFallback />}>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy" element={<Login showPoliciesOnLoad={true} />} />
        <Route path="/terms" element={<Login showPoliciesOnLoad={true} />} />

        {/* Main Product Routes */}
        <Route path="/:product" element={<Main />} />

        {/* Lazy-Loaded Demo Routes */}
        <Route path="/demo/customer-support" element={<CustomerSupport />} />
        <Route path="/demo/credit-card-reminder" element={<CreditCardReminder />} />
        <Route path="/demo/sales-assistance" element={<SalesAssistance />} />
        <Route path="/demo/appointment-booking" element={<AppointmentBooking />} />
        <Route path="/demo/extraction" element={<Extraction />} />
        <Route path="/demo/summarization" element={<Summarization />} />
        <Route path="/demo/transcription" element={<Transcription />} />
        <Route path="/demo/claims-triage" element={<ClaimsTriage />} />
        <Route path="/demo/inflow-insights" element={<Pos />} />
        <Route path="/demo/hospitality-insights" element={<Hospitality />} />
        <Route path="/demo/insight-sheets" element={<Excel />} />
        <Route path="/demo/avatar-bot" element={<AvatarVoice />} />
        <Route path="/demo/banking-assistant" element={<BankingAssistant />} />
        <Route path="/demo/clinical-assistant" element={<ClinicalAssistant />} />
        <Route path="/demo/virtual-mall-concierge" element={<VirtualMallConcierge />} />
        <Route path="/demo/psd-avatar" element={<PSDAvatar />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
